import Vue from 'vue';
import firebase from 'firebase/app';
import Router from 'vue-router';
import Home from './views/Dashboard.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/crew',
      name: 'Crew Management',
      component: () => import('./views/Crew.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/crew/m/:id',
      name: 'crew/m',
      component: () => import('./views/Member.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/assignments/:id',
      name: 'event assignments',
      component: () => import('./views/AddEventAssignments.vue'),
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const {currentUser} = firebase.auth();

  if (requiresAuth && !currentUser) {
    next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

export default router;
